import { useAtomValue } from 'jotai';

import type { FaultedDevice } from '../faulted-devices.types';
import FaultedDevicesState from '../state/faulted-devices.state';

/**
 * Faulted devices in All Equipment, whatever view is showing, sorted by equipment
 * type then title. Shared by the Faulted tab, the faulted alert, the section
 * badges and the reset pane so they all agree on which devices are faulted.
 */
export const useFaultedDevices = (): FaultedDevice[] => {
  return useAtomValue(FaultedDevicesState.faultedDevices);
};
